<template>
  <div>
    <div v-if="displayMode === 'edit'" class="social-containers">
      <div class="tag-containers">
        <div v-for="(social,index) in socialMedia" :key="index" :class="social.name">
          <div v-if="social.showTag" class="tag">
            <i v-if="social.name === 'linkedin'" :class="'fab '+ 'fa-'+social.name"> </i>
            <i v-else :class="'fab '+ 'fa-'+social.name + '-square'"> </i>
            <p>{{social.handle}}</p>
            <i class="fas fa-times-circle delete-icon"
               tabindex="0"
               @keypress.enter.space="deleteHandle(social)"
               v-on:click="deleteHandle(social)" />
          </div>
        </div>
      </div>
      <div v-if="filterShowIcon.length > 0" class="icon-input-container">
        <div class="icon-container">
          <div v-for="(social,index) in filterShowIcon"
               v-on:click="iconClicked(social)"
               :key="index" class="icons"
               tabindex="0"
               @keypress.enter.space="iconClicked(social)"
               :class="social.active">
            <i v-if="social.name === 'linkedin'" :class="'fab '+ 'fa-'+social.name"> </i>
            <i v-else-if="social.name === 'twitter'" :class="'fa-brands '+ 'fa-x-'+social.name"> </i>
            <i v-else :class="'fab '+ 'fa-'+social.name + '-square'"> </i>
          </div>
        </div>
        <div class="input-container">
          <div v-for="(social,index) in filterActive"
               class="inputsocial"
               :key="index">
              <input @keyup.enter="handleSubmitted(social)"
                     :placeholder="getSocialUser(social.name)"
                     v-model="social.handle">
              <div v-on:click="handleSubmitted(social)"
                   @keypress.space.enter="handleSubmitted(social)"
                   class="add-social-icon"
                   data-balloon="Add Social Handle"
                   data-balloon-pos="up">
                <i class="fal fa-plus-circle has-text-primary"
                   aria-hidden="true" />
              </div>
          </div>
        </div>
      </div>
      <div class="error" v-if="error">{{error}}</div>
    </div>
    <div v-if="displayMode === 'static'" class="social-containers-display">
      <div class="thumbnail-container">
        <div v-for="(social,index) in handlesStore" :key="index" :class="social.platform" class="thumbnail">
          <a :href="socialProfile(social)" target="_blank">
            <i v-if="social.platform === 'linkedin'" :class="['fab '+ 'fa-'+social.platform, social.platform]"> </i>
            <i v-else :class="['fab '+ 'fa-'+social.platform + '-square', social.platform]"> </i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import state from '../../Pages/Profile/state'
import componentState from '@/mixins/component-state'
import auth from '@/mixins/auth'

export default {
  name: 'socialhandles',
  props: ['displayMode', 'user'],
  data: function () {
    return {
      socialMedia: [
        {
          name: 'twitter',
          active: 'active',
          handle: '',
          showTag: false,
          showIcon: true
        },
        {
          name: 'reddit',
          active: '',
          handle: '',
          showTag: false,
          showIcon: true
        },
        {
          name: 'facebook',
          active: '',
          handle: '',
          showTag: false,
          showIcon: true
        },
        {
          name: 'linkedin',
          active: '',
          handle: '',
          showTag: false,
          showIcon: true
        },
        {
          name: 'pinterest',
          active: '',
          handle: '',
          showTag: false,
          showIcon: true
        },
        {
          name: 'instagram',
          active: '',
          handle: '',
          showTag: false,
          showIcon: true
        }
      ],
      error: '',
      isError: false
    }
  },
  mixins: [componentState, auth],
  mounted: function () {
    this.getSocialHandles()
  },
  watch: {
    user: function () {
      if (this.user?.id > 0) {
        this.getSocialHandles()
      }
    }
  },
  computed: {
    filterShowIcon: function () {
      return this.socialMedia.filter(social => social.showIcon)
    },
    filterActive: function () {
      return this.socialMedia.filter(social => social.active)
    },
    filterHandles: function () {
      return this.socialMedia.filter(social => social.handle)
    },
    handlesStore: function () {
      return this.$store.getters.handles
    },
    editable: function () {
      return this._get(state.editable.profile, false)
    }
  },
  methods: {
    getSocialUser: function (name) {
      if (name) {
        switch (this.$i18n.locale) {
          case 'fr':
            return 'Pseudo ' + name
          default:
            return name + ' username'
        }
      }
    },
    resetSocialHandle: function () {
      this.socialMedia = [
        {
          name: 'twitter',
          active: 'active',
          handle: '',
          showTag: false,
          showIcon: true
        },
        {
          name: 'reddit',
          active: '',
          handle: '',
          showTag: false,
          showIcon: true
        },
        {
          name: 'facebook',
          active: '',
          handle: '',
          showTag: false,
          showIcon: true
        },
        {
          name: 'linkedin',
          active: '',
          handle: '',
          showTag: false,
          showIcon: true
        },
        {
          name: 'pinterest',
          active: '',
          handle: '',
          showTag: false,
          showIcon: true
        },
        {
          name: 'instagram',
          active: '',
          handle: '',
          showTag: false,
          showIcon: true
        }
      ]
    },
    handleSubmitted: function (socialmedia) {
      if (!socialmedia.handle) {
        this.error = 'enter a handle'
        return
      }
      this.error = ''
      const data = {
        platform: socialmedia.name,
        handle: socialmedia.handle
      }
      this.$store.dispatch('saveSocialHandle', data).then(() => {
        socialmedia.active = ''
        socialmedia.showTag = true
        socialmedia.showIcon = false
        if (this.filterShowIcon?.length > 0) {
          this.filterShowIcon[0].showIcon = true
          this.filterShowIcon[0].active = 'active'
        }
        this.$emit('handlesAvailable', this.filterHandles.length)
      }, (error) => {
        this.error = error.message
      })
    },
    iconClicked: function (socialmedia) {
      this.socialMedia.forEach(social => {
        social.active = false
      })
      socialmedia.active = 'active'
    },
    deleteHandle: function (socialmedia) {
      const data = {
        platform: socialmedia.name,
        handle: socialmedia.handle
      }
      this.$store.dispatch('deleteSocialHandle', data).then(() => {
        if (this.filterShowIcon?.length < 1) {
          socialmedia.active = 'active'
        }
        socialmedia.showTag = false
        socialmedia.showIcon = true
        socialmedia.handle = ''
        this.$emit('handlesAvailable', this.filterHandles.length)
      }, (error) => {
        this.error = error.message
      })
    },
    socialProfile: function (social) {
      switch (social.platform) {
        case 'reddit':
          return 'https://' + social.platform + '.com/user/' + social.handle
        case 'linkedin':
          return 'https://' + social.platform + '.com/in/' + social.handle
        default:
          return 'https://' + social.platform + '.com/' + social.handle
      }
    },
    getSocialHandles: function () {
      let userId = this.currentUser?.id
      if (!this.editable && this.user?.id) {
        userId = this.user?.id
      }
      this.$store.dispatch('getSocialHandle', userId).then((response) => {
        if (response.result.handles.length > 0) {
          this.resetSocialHandle()
          response.result.handles.forEach((dbSocialMedia) => {
            this.socialMedia.find((socialMedia) => {
              if (socialMedia.name === dbSocialMedia.platform) {
                socialMedia.handle = dbSocialMedia.handle
                socialMedia.active = ''
                socialMedia.showTag = true
                socialMedia.showIcon = false
              }
            })
          })
          if (this.filterShowIcon?.length > 0) {
            this.filterShowIcon[0].active = 'active'
          }
        }
        this.$emit('handlesAvailable', this.filterHandles.length)
      }, (error) => {
        this.errorMessage = error
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .social-containers {
    padding-top: 1rem;
    p {
      font-size: 0.9rem;
      font-weight: 500;
    }
  }

  .icon-input-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    @include mobile {
      flex-direction: column;
    }
  }

  .icon-container {
    height: 40px;
    width: 48.5%;
    display: flex;
    justify-content: flex-end;
    padding-right: 2.4rem;
    padding-left: 4rem;
    @include mobile {
      padding: 0;
      justify-content: center;
    }
  }

  .icons {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .active i {
    color: $primary;
  }

  .icons i {
    font-size: 2rem;
    margin-right: 0.25rem;
  }

  .icons i:hover {
    color: $primary;
  }

  .add-social-icon {
    color: $primary;
    margin-left: .5rem;
    font-size: 1.5rem;
    display: flex;
  }

  .tag {
    margin-right: 0.5rem;
    color: black;
    margin-bottom: 0.5rem;
    padding-right: 0;
    p {
      max-width: 150px;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .delete-icon {
      color: white;
      padding-left: 0.25rem;
      cursor : pointer;
    }
  }

  .tag i {
    padding-right: 0.25rem;
    font-size: 0.9rem;
  }

  .twitter .tag{
    background-color: #00ACEE;
  }

  .reddit .tag {
    background-color: #FF7832;
  }

  .linkedin .tag {
    background-color: #6EACCA;
  }

  .facebook .tag {
    background-color: #758AB6;
  }
  .instagram .tag {
    background-color: #957DAD;
  }

  .pinterest .tag {
    background-color: #ff4c4c;
  }

  .thumbnail .twitter {
    color: #00ACEE;
  }

  .thumbnail .reddit {
    color: #FF7832;
  }

  .thumbnail .linkedin{
    color: #6EACCA;
  }

  .thumbnail .facebook{
    color: #758AB6;
  }

  .thumbnail .instagram {
    color: #957DAD;
  }

  .thumbnail .pinterest{
    color: #ff4c4c;
  }

  .thumbnail i:hover {
    color: $primary;
    transition: color 0.35s;
  }

  .input-container {
    display: flex;
    align-items: center;
    width: 61.5%;
    @include mobile {
      justify-content: center;
    }
  }

  .tag-containers {
    display: flex;
    justify-content: center;
    max-width: 100%;
    flex-wrap: wrap;
    padding: 0 5%;
  }

  .inputsocial {
    display: flex;
    align-items: center;
    input {
      padding-left: 1rem;
      border: none;
      box-shadow: none;
      border-radius: .2rem;
      height: 40px;
      font-size: .85rem;
      transition: .1s;
    }
  }
  .error {
    margin-top: 0.5rem;
    color: red;
    font-size: 0.9rem;
  }
  .thumbnail-container {
    display: flex;
    .thumbnail {
      font-size: 1.5rem;
      margin-right: 0.35rem;
    }
  }
</style>
